import React from 'react';

function PageNotFound() {
  return (
    <div className='vh-100 d-flex justify-content-center align-items-center'>
      <div className='text-center'>
        <h1 className='not-found-title'>
          404
        </h1>
        <h2>
          Page Not Found
        </h2>
      </div>
    </div>
  )
}

export default PageNotFound
